import { CoreContext } from 'context/CoreContext'
import React, { useContext, useMemo } from 'react'
import { CompanyButtonContainer, ModalContainer } from './styled'
import Wrapper from '../Wrapper';
import Button from 'components/Form/Button';
import FormCore from '../../Form/Core'
import { industryOptions } from 'utils/options';
import useForm from 'hooks/useForm';
import useI18n from 'hooks/useI18n';

export default function ModalNewTicket() {

  const { modal, setModal } = useContext(CoreContext)

  const { t } = useI18n()

  const close = () => {
    setModal(null)
  }

  const handleSave = () => {
    if(typeof modal?.reload === 'function'){ modal?.reload() ;}
    close()
  }

  const formItems = useMemo(() => [
    {
      ref: 'title',
      placeholder: t('subject'),
      half: true
    },
    {
      ref: 'industry',
      placeholder: t('area_departament'),
      options: industryOptions,
      half: true
    },
    {
      ref: 'description',
      placeholder: t('message'),
      type: 'textarea',
      full: true
    },
  ], [ t ])

  const { register, save, loading, formRef } = useForm({ table:"supports", success: () => handleSave() })

  const doSave = async () => {
    await save({ status:"pending" })
  }

  return (
    <>
      <Wrapper title={t('create_a_new_ticket')} text={t('describe_as_soon_as_possible')}>
        <ModalContainer>
          <FormCore ref={formRef} register={register} formItems={formItems} />
        </ModalContainer>
        <CompanyButtonContainer>
          <Button onClick={close} width={'120px'} outline color='primary' small nospace>{t('cancel')}</Button>
          <Button color="blue" loading={loading} onClick={doSave} width={'120px'} small between nospace>{t('send')}</Button>
        </CompanyButtonContainer>
      </Wrapper>
    </>
  )
}
